import React from "react";
import TimesheetFull from "../../../../../components/TimeSheet/TimesheetFull";
import { timesheetTableData } from "../../../../../assets/data/candidatesData";

const TimeSheetList = () => {
  return (
    <div className="flex-1 flex overflow-hidden">
      <TimesheetFull />
    </div>
  );
};

export default TimeSheetList;
